module.exports = __webpack_public_path__ + "assets/img/tx30g_3.c31c2424.jpg";